import { useLocalSearchParams } from "expo-router";
import React from "react";
import slugify from "slugify";

import NotFound from "@/app/+not-found";
import EventPage from "@/pages/Event/EventPage";
import { PRIDE_EVENTS_2025 } from "@/screens/Content/Feed/EventsTab/Hooks/data";

export async function generateStaticParams(): Promise<
  Record<string, string>[]
> {
  return PRIDE_EVENTS_2025.map((event) => ({
    eventSlug: slugify(`${event.id}-${event.title}`),
  }));
}

export default function Page(): React.JSX.Element {
  const { eventSlug } = useLocalSearchParams<{ eventSlug: string }>();

  if (!eventSlug) {
    return <NotFound />;
  } else {
    const [eventId] = eventSlug?.split("-") ?? [];

    if (eventId !== undefined) {
      return <EventPage eventId={eventId} />;
    } else {
      return <NotFound />;
    }
  }
}
